// extracted by mini-css-extract-plugin
export default {"container":"style_container__mKGSs","form-controls":"style_form-controls__j8WNb","content":"style_content__ueZli","buttonBlock":"style_buttonBlock__8gXs0"};